import {OPEN_COOKIE_PREFERENCES_EVENT} from '../consts';

export function openCookiePreferences(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT));
}
